import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FaqComponent } from './faq/faq.component';
import { LandingHomepageComponent } from './landing/landing-homepage.component';
import { AuthGuard } from './shared/auth.guard';
import { WellcomeComponent } from './wellcome/wellcome.component';

const appRoutes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: 'landing'
  },
  {
    path: 'wellcome', component: WellcomeComponent
  },
  {
    path: 'landing', component: LandingHomepageComponent
  },
  {
    path: 'login',
    loadChildren: () => import('./login/landing-login.module').then(m => m.LandingLoginModule)
  },
  {
    path: 'faq', component: FaqComponent
  },
  {
    path: 'inner-menu',
    loadChildren: () => import('./inner-menu/inner-menu.module').then(m => m.InnerMenuModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'landing'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
